import * as React from 'react';
import closeProjection from 'owa-popout-v2/lib/actions/closeProjection';
import renderProjection from 'owa-popout-v2/lib/utils/renderProjection';
import { observer } from 'mobx-react-lite';
import { TabViewState, TabType } from 'owa-tab-store';
import { getStore as getComposeStore } from 'owa-mail-compose-store';
import { ProjectionCompose } from 'owa-mail-compose-view';

export interface ProjectionPopoutProps {
    viewState: TabViewState;
}

/**
 * This is a bridge component between parent window and popout window. It renders nothing to parent window,
 * but it will call renderProjection to render the components into popout window.
 */
export default observer(function ProjectionPopout(props: ProjectionPopoutProps) {
    React.useEffect(() => {
        const { viewState } = props;
        let content: JSX.Element = null;
        switch (viewState.type) {
            case TabType.Compose:
                content = renderCompose(viewState.data);
                break;
        }

        if (content) {
            renderProjection(viewState.id, content);
        }

        return () => {
            closeProjection(viewState.id);
        };
    }, []);

    return null;
});

function renderCompose(composeId: string): JSX.Element {
    const composeViewState = getComposeStore().viewStates.get(composeId);
    return composeViewState && <ProjectionCompose viewState={composeViewState} />;
}
